/* eslint-disable @tencent/i18next/no-literal-string */
import {
    IFontUseNumberResult,
} from '@src/slide/application/service/slide-rating-and-improve/text/text-analyzer.interface';
import { AnalyzerResultDescriptionAndToSelectModel, AnalyzerResultType } from '../../slide-content-analyzer.interface';
import i18n from '@i18next/i18n';

export class FontUseNumberResult implements IFontUseNumberResult {
    public analyzerName: string;
    public description: string;
    public resultInfo: number;
    public resultType: AnalyzerResultType;
    /**
     * 使用的中文字体
     * @private
     */
    public eaFontSet = new Set();
    public latinFontSet = new Set();
    public constructor(
        analyzerName: string,
        description: string,
        private showUniformFontUI: (onHandled: () => void, onCancel: () => void) => void,
    ) {
        this.analyzerName = analyzerName;
        this.description = description;
        this.resultType = AnalyzerResultType.SUCCESS;
    }

    public reset() {
        this.resultType = AnalyzerResultType.SUCCESS;
        this.eaFontSet.clear();
        this.latinFontSet.clear();
    }

    public getDescriptionWithSelect(): Array<AnalyzerResultDescriptionAndToSelectModel> | undefined {
        if (this.resultType === AnalyzerResultType.SUCCESS) return undefined;
        return [{
            description: i18n.t('共使用了{0}种字体，建议不超过4种', { 0: this.resultInfo }),
            selectable: false,
        }];
    }

    public handleProblem(onHandled: () => void, onCancel: () => void) {
        this.showUniformFontUI(onHandled, onCancel);
    }
}
